import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useUploadDriversListExcel = () => {
    const modalContext = useContext(ModalContext);
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onUploadDriversListExcelError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while creating drivers account.',
        );
    };

    const onUploadDriversListExcelSuccess = (resetForm: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Drivers accounts created successfully.');
        modalContext?.setShowSuccessComponent(true);
        resetForm();
    };

    const uploadDriversListExcel = (data: any, resetForm: () => void) => {
        const formData = new FormData();

        if (data?.excelFile?.length > 0 && data.excelFile[0] instanceof File) {
            formData.append('file', data.excelFile[0], data.excelFile[0].name);
        } else {
            console.warn('No valid excelFile provided');
        }

        const url: HttpConfig = {
            url: 'api/v1/dispatchers/upload-dispatcher-excel',
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        request(url, onUploadDriversListExcelSuccess(resetForm), setLoading, onUploadDriversListExcelError);
    };

    return { uploadDriversListExcel, loading };
};

export default useUploadDriversListExcel;
